// extracted by mini-css-extract-plugin
export default {"wrapper":"headStages_wrapper__ZpVUM","title":"headStages_title__O+bhL","iconPencil":"headStages_iconPencil__zdIjc","text":"headStages_text__tpZTY"};